import actionNames from './actionNames'

const mutations = {
  [actionNames.ROUTE_CHANGED](state, newRoute) {
    state.currentRoute = newRoute
  },

  darkMode(state, darkMode) {
    state.darkMode = darkMode
  },

  drawerDragStartX(state, drawerDragStartX) {
    state.drawerDragStartX = drawerDragStartX
  },
  drawerDragStartWidth(state, drawerDragStartWidth) {
    state.drawerDragStartWidth = drawerDragStartWidth
  },
  drawerWidth(state, drawerWidth) {
    state.drawerWidth = drawerWidth
  },

  formContact(state, formContact) {
    state.formContact = formContact
  },
  formCustomAnalytic(state, formCustomAnalytic) {
    state.formCustomAnalytic = formCustomAnalytic
  },
  formNetwork(state, formNetwork) {
    state.formNetwork = formNetwork
  },
  formQuery(state, { formName, value }) {
    state.formQuery[formName] = value
  },
  formShare(state, formShare) {
    state.formShare = formShare
  },

  isModalVisibleContact(state, isModalVisibleContact) {
    state.isModalVisibleContact = isModalVisibleContact
  },
  isModalVisibleCustomAnalytic(state, isModalVisibleCustomAnalytic) {
    state.isModalVisibleCustomAnalytic = isModalVisibleCustomAnalytic
  },
  isModalVisibleNetwork(state, isModalVisibleNetwork) {
    state.isModalVisibleNetwork = isModalVisibleNetwork
  },
  isModalVisibleSettings(state, isModalVisibleSettings) {
    state.isModalVisibleSettings = isModalVisibleSettings
  },
  isModalVisibleQuery(state, isModalVisibleQuery) {
    state.isModalVisibleQuery = isModalVisibleQuery
  },
  isModalVisibleShare(state, isModalVisibleShare) {
    state.isModalVisibleShare = isModalVisibleShare
  },

  isLayoutFullScreen(state, isLayoutFullScreen) {
    state.isLayoutFullScreen = isLayoutFullScreen
  },
  isNavCollapsed(state, isNavCollapsed) {
    const givenValue = [true, false].includes(isNavCollapsed)
    const valueToStore = givenValue ? isNavCollapsed : !state.isNavCollapsed

    state.isNavCollapsed = valueToStore

    window.localStorage.setItem(state.STORAGE_KEY_NAV_STATE, valueToStore)
  },
  isResizingNavigation(state, isResizingNavigation) {
    state.isResizingNavigation = isResizingNavigation
  },

  promptError(state, showHide) {
    state.promptError = showHide
  },
  promptRefresh(state, showHide) {
    state.promptRefresh = showHide
  },
  serviceWorkerRegistration(state, serviceWorkerRegistration) {
    state.serviceWorkerRegistration = serviceWorkerRegistration
  },
}

export default mutations
